import { post } from '@/api/http.js';
// sleep
export function sleep(time) {
  return new Promise(resolve => setTimeout(resolve, time));
}

// 判断对象长度
export function checkObjLen(data) {
  if (Object.keys(data).length > 0) {
    return true;
  } else {
    return false;
  }
}

export function inArray(arr, value) {
  if (!Array.isArray(arr)) return false;
  let target = arr.find(ele => ele == value);

  return target != undefined ? true : false;
}

// 检测当前是否当前审核项
export function isIncludeInAudit(source, type, id) {
  if (!source[type]) return '';

  if (Array.isArray(source[type])) {
    let findRs = source[type].find(ele => ele == id);
    return findRs ? 'danger' : '';
  } else {
    return source[type] == id ? 'danger' : '';
  }
}

export function showDrawerPass(_this, ref, func, args) {
  if (_this.$refs[ref]) {
    _this.$refs[ref][func].apply(_this, args)
  } else {
    this.$nextTick(function () {
      _this.$refs[ref][func].apply(_this, args)
    })
  }
}

// 字符串转数组，先这样命名
export function getArray(data) {
  if (Array.isArray(data)) {
    return data;
  } else if (typeof data == 'string') {
    return data.length > 0 ? data.split(',') : [];
  } else {
    return [];
  }
}
// 验证数据权限
export function checkDataAuth() {
  let url = '/api/ucenter.user/auth';
  return new Promise((resolve, reject) => {
    post(url, {}).then(res => {
      if (res.code == '200') {
        resolve(res.data.role);
      } else {
        reject(false)
      }
    });
  })
}

// 对象数组求和
export function objectSum(items, field) {
  let sum = 0;
  items.forEach(item => {
    sum += parseFloat(item[field]);
  })
  return sum;
}
//检测数组是否包含  JavaScript Array includes() 对于类型格式较严 
export function include(target, arr) {
  return arr.find(ele => ele == target)
}
// 一维数组求和
export function arraySum(items) {
  let sum = 0;
  items.forEach(item => {
    sum += parseFloat(item);
  })

  return sum;
}

// 获取审核状态
export function getItemCheckTitle(id) {

  let arr = [
    { id: -1, title: "待执行" },
    { id: 0, title: "待审核" },
    { id: 1, title: "审核中" },
    { id: 2, title: "审核通过" },
    { id: 3, title: "审核驳回" },
  ];

  let target = arr.find(ele => ele.id == id);
  return target ? target['title'] : '-';
}
//数组对象字符串转数组
export function stringToObject(data) {
  if (typeof (data) != 'string') return data;

  return JSON.parse(data);
}
export function dateDD(strTime) {

  let st = strTime.substring(0, strTime.indexOf(' '));
  return st
}
export function dateFormat(time) {
  var date = new Date(time);
  var year = date.getFullYear();
  /* 在日期格式中，月份是从0开始的，因此要加0
   * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
   * */
  var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
  var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  // 拼接
  return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
}
//时间戳转时分秒
export function timestampToTime(timestamp) {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  const hour = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
  const minute = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
  const getSeconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
  return `${year}-${month}-${day} ${hour}:${minute}:${getSeconds}`;
}
//秒转时分秒
export function secondsToHms(d) {
  d = Number(d);
  var h = Math.floor(d / 3600);
  var m = Math.floor(d % 3600 / 60);
  var s = Math.floor(d % 3600 % 60);
  h = h < 10 ? '0' + h : h
  m = m < 10 ? '0' + m : m
  s = s < 10 ? '0' + s : s
  return `${h}小时${m}分钟${s}秒`
}
export function getTableHeight() {
  return window.innerHeight - 287
}
